/** @format */

'use strict';
// Generated by jhipster/controller/genericOverviewWithPaging.ftl

angular
	.module('emsApp')
	.controller('ArticleRelationPriceController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		ArticleRelationPriceFactory,
		FindAllArticleRelationPricesByQueryParamsFactory,
		AutocompleteRelationsByQueryParamsFactory,
		NoPagingArticleRelationPriceFactory,
		NoPagingRelationFactory,
		NoPagingArticleFactory
	) {
		$scope.articleRelationPriceList = [];
		$scope.showSearchForm = true;
		// a custom hook could be implemented here to add additional fields: custom/jhipster/controller/overview/additional-fields.ftl

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeArticleRelationPrice)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeArticleRelationPrice);
		} else {
			$scope.pageSize = 20;
			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeArticleRelationPrice = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is NOT mapped, it is the main overview
			$state.go('articlerelationprice.list.new');
		};

		$scope.goToEditState = function(articleRelationPrice) {
			// this overview is NOT mapped, it is the main overview
			$state.go('articlerelationprice.list.edit', { articleRelationPriceId: articleRelationPrice.id });
		};

		var getRelationId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.ArticleRelationPriceSearchOverview.relation)) {
				return $scope.ArticleRelationPriceSearchOverview.relation.id;
			} else {
				return undefined;
			}
		};

		var getArticleId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.ArticleRelationPriceSearchOverview.article)) {
				return $scope.ArticleRelationPriceSearchOverview.article.id;
			} else {
				return undefined;
			}
		};

		$scope.autocompleteRelations = function(val) {
			var params = {
				relationTypeAheadSearchString: val,
			};

			return AutocompleteRelationsByQueryParamsFactory.query(params).$promise.then(function(results) {
				return results;
			});
		};

		/**
		 * This function queries all entities of type Article and checks if this ArticleRelationPrice dialog is called in the context of Article.
		 * If this is the case, we detect the parent entity ArticleRelationPrice and select it as model value so it is shown in the dropdown select.
		 */
		$scope.queryArticle = function() {
			return NoPagingArticleFactory.query(function(result) {
				return result;
			});
		};
		$scope.articleReferenceFilterList = $scope.queryArticle();
		$scope.search = function() {
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.ArticleRelationPriceSearchOverview = angular.copy($scope.ArticleRelationPriceSearchOverview);

			// A custom hook for setting page size can be implemented here: custom/jhipster/controller/overview/overview_uses_paging.ftl
			$rootScope.pageSizeArticleRelationPrice = angular.copy($scope.pageSize);

			FindAllArticleRelationPricesByQueryParamsFactory.query(
				{
					page: $scope.ArticleRelationPriceSearchOverview.page - 1,
					size: $scope.pageSize,
					relationId: getRelationId(),
					articleId: getArticleId(),

					sort: [
						$scope.ArticleRelationPriceSearchOverview.predicate +
							',' +
							($scope.ArticleRelationPriceSearchOverview.ascending ? 'asc' : 'desc'),
					],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.articleRelationPriceList = result;
					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isArticleRelationPriceSearchOverviewDirty = function() {
			return !angular.equals($scope.ArticleRelationPriceSearchOverview, $scope.originalArticleRelationPriceSearchOverview);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.ArticleRelationPriceSearchOverview = {};
			$rootScope.ArticleRelationPriceSearchOverview.page = 1;
			$rootScope.ArticleRelationPriceSearchOverview.predicate = 'id';
			$rootScope.ArticleRelationPriceSearchOverview.ascending = false;

			$scope.ArticleRelationPriceSearchOverview = angular.copy($rootScope.ArticleRelationPriceSearchOverview);

			$scope.originalArticleRelationPriceSearchOverview = angular.copy($scope.ArticleRelationPriceSearchOverview);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.ArticleRelationPriceSearchOverview) || $rootScope.ArticleRelationPriceSearchOverview === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.ArticleRelationPriceSearchOverview = angular.copy($rootScope.ArticleRelationPriceSearchOverview);
			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedArticleRelationPriceId = id;
			$('#deleteArticleRelationPriceConfirmation').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			ArticleRelationPriceFactory.delete(
				{ id: $scope.selectedArticleRelationPriceId },
				function() {
					$scope.search();
					$('#deleteArticleRelationPriceConfirmation').modal('hide');
				},
				function(error) {
					$('#deleteArticleRelationPriceConfirmation').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.ArticleRelationPriceSearchOverview.predicate === itemName) {
				if ($scope.ArticleRelationPriceSearchOverview.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});
